import React, { lazy, Suspense } from 'react';
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { Auth } from "./Auth/Auth";
import { Pages } from "./Pages/Pages";
import RootRouteGuard from "./RootRouteGuard";
import ErrorBoundary from "../components/ErrorFallback";
import ChunkErrorBoundary from "../components/ChunkErrorBoundary";

const LiveAuditStatusPage = lazy(() => import("../features/audits/components/liveAudit/LiveAuditStatusPage"));

const PageLoader = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px'
  }}>
    Loading...
  </div>
);

const router = createBrowserRouter([
  {
    path: "/store/:id/audit-live-status",
    element: (
      <ErrorBoundary>
        <ChunkErrorBoundary>
          <Suspense fallback={<PageLoader />}>
            <LiveAuditStatusPage />
          </Suspense>
        </ChunkErrorBoundary>
      </ErrorBoundary>
    ),
  },
  {
    element: <RootRouteGuard />,
    children: [
      // Auth routes (marketing pages, login, etc.)
      Auth,
      // Protected pages
      Pages
    ]
  }
], {
  basename: '/app'
});

function Router(): React.JSX.Element {
  return <RouterProvider router={router} />;
}

export default Router;
